import React from 'react';

const Icon = (props) => (
  <span className={`icon ${props.className ? props.className : ''}`} style={{ backgroundImage: `url(${props.imageUrl})`}}>
  </span>
);
export default Icon;


// WEBPACK FOOTER //
// ./src/components/icon/icon.js